import PATH from 'constants/basePath';

export default [
  PATH.VARIABLE_MESSAGE_BOARD_PUBLIC,
  PATH.TICKET_RESERVATION_WEBSITE.BASE_URL,
  PATH.TICKET_RESERVATION_WEBSITE.TO_PAY,
  PATH.TICKET_RESERVATION_WEBSITE.MY_ORDERS,
  PATH.TICKET_RESERVATION_WEBSITE.PROFILE,
];
